export default __webpack_public_path__ + "static/media/mind-icon.b9c932f7.svg";